// Globals
import { useTranslation } from 'react-i18next';

// Modules
import { StyledTag } from '@/modules/Order';

// Components
import { ArrowRightIcon } from '@/icons';
import { StyledBlock } from './LogDiffStyles';

// Models
import { IDiffState } from '@/models/logs.model';

type TLogDiff = {
  oldState: IDiffState;
  newState: IDiffState;
};

const LogDiff = ({ oldState, newState }: TLogDiff) => {
  const { t } = useTranslation('order');
  return (
    <StyledBlock>
      <StyledTag $status={oldState.status}>
        {t('status', {
          context: oldState.status,
          ns: 'order',
        })}
      </StyledTag>
      <ArrowRightIcon />
      <StyledTag $status={newState.status}>
        {t('status', {
          context: newState.status,
        })}
      </StyledTag>
    </StyledBlock>
  );
};

export default LogDiff;
